import React, { useContext } from "react";
import { getClassName } from "@sscs/utils";
import { Collapse } from "../../";
import context from "./context";
import styles from "./expandedRow.module.scss";
const Details = ({ className, children }) => {
    const { expanded } = useContext(context);
    return (React.createElement(Collapse, { transitionIn: expanded, className: getClassName(styles["details-content"], className) }, children));
};
export default Details;
//# sourceMappingURL=Details.js.map